import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RouteGuard } from '../../shared/guards/route.guard';
import { WellbeingHubComponent } from './wellbeing-hub.component';

const routes: Routes = [
  {
    path: 'wellbeing-hub',
    pathMatch: 'full',
    component: WellbeingHubComponent,
    canActivate: [RouteGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WellbeingHubRoutingModule { }
